import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import * as headings from './Headings';
import { Code } from './Code';
import { Layout } from './Layout';
import { Playground } from './Playground';
import { Pre } from './Pre';
import { Props } from './Props';
export default _objectSpread(_objectSpread({}, headings), {}, {
  code: Code,
  playground: Playground,
  pre: Pre,
  layout: Layout,
  props: Props
});
if (typeof props !== 'undefined' && props && props === Object(props) && Object.isExtensible(props) && !Object.prototype.hasOwnProperty.call(props, '__filemeta')) {
  Object.defineProperty(props, '__filemeta', {
    configurable: true,
    value: {
      name: "props",
      filename: "node_modules/gatsby-theme-docz/src/components/index.js"
    }
  });
}
if (typeof layout !== 'undefined' && layout && layout === Object(layout) && Object.isExtensible(layout) && !Object.prototype.hasOwnProperty.call(layout, '__filemeta')) {
  Object.defineProperty(layout, '__filemeta', {
    configurable: true,
    value: {
      name: "layout",
      filename: "node_modules/gatsby-theme-docz/src/components/index.js"
    }
  });
}
if (typeof pre !== 'undefined' && pre && pre === Object(pre) && Object.isExtensible(pre) && !Object.prototype.hasOwnProperty.call(pre, '__filemeta')) {
  Object.defineProperty(pre, '__filemeta', {
    configurable: true,
    value: {
      name: "pre",
      filename: "node_modules/gatsby-theme-docz/src/components/index.js"
    }
  });
}
if (typeof playground !== 'undefined' && playground && playground === Object(playground) && Object.isExtensible(playground) && !Object.prototype.hasOwnProperty.call(playground, '__filemeta')) {
  Object.defineProperty(playground, '__filemeta', {
    configurable: true,
    value: {
      name: "playground",
      filename: "node_modules/gatsby-theme-docz/src/components/index.js"
    }
  });
}
if (typeof code !== 'undefined' && code && code === Object(code) && Object.isExtensible(code) && !Object.prototype.hasOwnProperty.call(code, '__filemeta')) {
  Object.defineProperty(code, '__filemeta', {
    configurable: true,
    value: {
      name: "code",
      filename: "node_modules/gatsby-theme-docz/src/components/index.js"
    }
  });
}